// Rotas públicas (sem login). Fonte ÚNICA consumida pelo VersionChecker e pelo Amplifique
// para não incomodar (modal de update / survey NPS) usuário anônimo em fluxos públicos.
// Antes cada componente tinha metade da lista: Amplifique cobria /chamado, o VersionChecker
// (na versão da desenv) cobria /qr — aqui unifica os dois.
export const PUBLIC_ROUTE_PREFIXES = ['/qr', '/chamado', '/login', '/logout', '/login-sso'];

/**
 * true se o pathname é uma rota pública. Match por segmento: igual ao prefixo
 * ('/qr') ou sob ele ('/qr/ABC') — mas NÃO um prefixo textual acidental ('/qrcode').
 */
export const isPublicRoute = (pathname: string): boolean =>
  PUBLIC_ROUTE_PREFIXES.some(prefix => pathname === prefix || pathname.startsWith(`${prefix}/`));
